import { callMessagingFunction } from './callableMessagingClient';

export const MAX_CHAT_PROMOTION_MESSAGES = 20;
export const MAX_CHAT_PROMOTION_STATE_MESSAGES = 100;

export const loadMessageLifelogStates = async ({ messages = [], conversation, deps = {} } = {}) => {
  const messageIds = [...new Set(messages.map((message) => message?.id).filter(Boolean))].slice(-MAX_CHAT_PROMOTION_STATE_MESSAGES);
  if (!conversation?.id || messageIds.length === 0) return { ok: true, promotions: {} };
  const call = deps.callMessagingFunction || callMessagingFunction;
  return call('getChatMessagePromotionStates', { conversationId: conversation.id, messageIds });
};

export const addMessageToLifelog = async ({
  message,
  conversation,
  deps = {},
} = {}) => {
  if (!message?.id || !conversation?.id) {
    throw new Error('This message cannot be added to Lifelog.');
  }
  const call = deps.callMessagingFunction || callMessagingFunction;
  return call('promoteChatMessageToLifelog', {
    conversationId: conversation.id,
    messageId: message.id,
  });
};

export const addMessagesToLifelog = async ({ messages = [], conversation, deps = {} } = {}) => {
  const messageIds = [...new Set(messages.map((message) => message?.id).filter(Boolean))];
  if (!conversation?.id || messageIds.length < 2) {
    throw new Error('Select at least two messages to add together.');
  }
  if (messageIds.length > MAX_CHAT_PROMOTION_MESSAGES) {
    throw new Error(`Select no more than ${MAX_CHAT_PROMOTION_MESSAGES} messages.`);
  }
  const call = deps.callMessagingFunction || callMessagingFunction;
  return call('promoteChatMessagesToLifelog', {
    conversationId: conversation.id,
    messageIds,
  });
};
